import './overrides.css'

import {
	Box,
	Flex,
	Menu,
	MenuButton,
	MenuList,
	useEventListener,
} from '@chakra-ui/react'
import { useKnockFeed } from '@knocklabs/react'
import { ReactNode, useRef } from 'react'

import { useAppDispatch, useAppSelector } from '@/app/hooks'

import { notificationsActions } from '../slice'
import { selectIsNotificationsOpen } from '../slice/selectors'
import { NotificationCenter } from './NotificationCenter'

type WithNotificationsProps = {
	children: (props: {
		isOpen: boolean
		setIsOpen: (isOpen: boolean) => void
		unreadCount: number
	}) => ReactNode
}

export const WithNotifications = ({ children }: WithNotificationsProps) => {
	const { useFeedStore } = useKnockFeed()
	const { items } = useFeedStore()
	const dispatch = useAppDispatch()
	const isOpen = useAppSelector(selectIsNotificationsOpen)
	const containerRef = useRef<HTMLDivElement>(null)
	const menuRef = useRef<HTMLDivElement>(null)

	// Action to set notifications open state
	const setIsOpen = (newIsOpen: boolean) => {
		dispatch(notificationsActions.setNotificationsOpen(newIsOpen))
	}

	const handleDocumentClick = (e: MouseEvent) => {
		if (!isOpen) return

		if (
			containerRef.current &&
			!containerRef.current.contains(e.target as Node) &&
			menuRef.current &&
			!menuRef.current.contains(e.target as Node)
		) {
			setIsOpen(false)
		}
	}

	useEventListener('mousedown', handleDocumentClick)

	return (
		<Flex ref={containerRef} w="full" onClick={(e) => e.stopPropagation()}>
			<Flex
				bg="#000000"
				pos="fixed"
				top={0}
				left={0}
				w={isOpen ? '100vw' : '0'}
				h="100vh"
				zIndex={10000}
				opacity={isOpen ? 0.12 : 0}
				transition="opacity 0.2s ease-out"
				pointerEvents={isOpen ? 'auto' : 'none'}
				onClick={() => setIsOpen(false)}
			/>
			<Menu isOpen={isOpen} placement="right-start">
				{children({
					isOpen,
					setIsOpen,
					unreadCount: items.filter((item) => !item.read_at).length,
				})}
				<MenuButton as={Box} />
				<MenuList
					ref={menuRef}
					p={0}
					w="420px"
					h="calc(100vh - 20px)"
					m="10px"
					pointerEvents="auto"
					zIndex={10001}
				>
					<NotificationCenter setIsOpen={setIsOpen} />
				</MenuList>
			</Menu>
		</Flex>
	)
}
